import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormField } from '@angular/forms/signals';
import { Subscription } from 'rxjs';
import { ManageBriefTabsService } from '../../../../service/manage-brief-tabs/manage-brief-tabs.service';
import { TooltipDirective } from '../../../../../../common/directives/tooltip/tooltip.directive';
import { BriefResponseDto } from '../../../../../../common/general-types/briefs.dto';
import { EditPostRequirementsService } from './service/edit-post-requirements-service';

@Component({
  selector: 'mbt-briefing-post-requirements',
  imports: [TooltipDirective, FormsModule, FormField],
  templateUrl: './briefing-post-requirements.html',
  styleUrl: './briefing-post-requirements.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BriefingPostRequirements implements OnDestroy {

  subscriptionList = new Subscription();

  /** Services */
  public readonly manageBriefTabsService = inject(ManageBriefTabsService);
  public readonly editPostRequirementsService = inject(EditPostRequirementsService);
  /** Services - END */

  editPostRequirements() {
    const brief = this.manageBriefTabsService.focussedBrief();
    if (!brief) {
      return;
    }

    const enteringEdit = !this.editPostRequirementsService.editingPostRequirements();
    this.editPostRequirementsService.editingPostRequirements.set(enteringEdit);
    this.editPostRequirementsService.focussedBriefId.set(brief.id);

    if (enteringEdit) {
      const shoutBrief = brief.shoutBrief;
      this.editPostRequirementsService.postRequirementsModel.set({
        suggestedCaption: shoutBrief?.suggestedCaption ?? '',
        suggestedHastags: shoutBrief?.suggestedHastags ?? '',
        callToActionLink: shoutBrief?.callToActionLink ?? '',
      });
    }
  }

  savePostRequirementsChanges() {
    this.editPostRequirementsService.editInProgress.set(true);

    const model = this.editPostRequirementsService.postRequirementsModel();
    const payload = {
      suggestedCaption: model.suggestedCaption,
      suggestedHastags: model.suggestedHastags,
      callToActionLink: model.callToActionLink,
    };

    this.subscriptionList.add(
      this.editPostRequirementsService.savePostRequirements(payload).subscribe({
        next: (response: BriefResponseDto) => {
          this.manageBriefTabsService.focussedBrief.set(response);
          this.editPostRequirementsService.editInProgress.set(false);
          this.editPostRequirementsService.editingPostRequirements.set(false);
        },
        error: () => {
          this.editPostRequirementsService.editInProgress.set(false);
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }
}
